import React from 'react';
import { useSelector } from 'react-redux';
import SocialShareModalAICaptionsField from 'containers/SocialShareModal/SocialShareModalAICaptionsField';
import SocialShareModalBody from 'containers/SocialShareModal/SocialShareModalBody';
import { useSocialShareModal } from 'containers/SocialShareModal/SocialShareModalContext';
import { useSocialSharePlatform } from 'containers/SocialShareModal/SocialSharePlatforms/SocialSharePlatformContext';
import { linkedinIsPostingSelector } from 'redux/modules/social';
import { socialShareModalBlock as block } from '../../../../utils';
import { LINKEDIN_MAX_DESCRIPTION_CHARS } from './constants';
import LinkedInPostInfoBox from './LinkedInPostInfoBox';

export type LinkedInPostComposerStepProps = {};

const LinkedInPostComposerStep: React.FC<LinkedInPostComposerStepProps> = () => {
  const isPosting = useSelector(linkedinIsPostingSelector);

  const { description, setDescription } = useSocialShareModal();
  const { authenticating } = useSocialSharePlatform();

  return (
    <SocialShareModalBody
      loadingTitle="Posting Video"
      isLoading={isPosting}
      className={block('linkedin-post-composer-step-container')}
    >
      <SocialShareModalAICaptionsField
        inputProps={{
          value: description,
          maxChars: LINKEDIN_MAX_DESCRIPTION_CHARS,
          onChange: setDescription,
        }}
      />

      {!authenticating && <LinkedInPostInfoBox />}
    </SocialShareModalBody>
  );
};

export default LinkedInPostComposerStep;
